export default "__VITE_ASSET__mIQSAHdN__"